import { BANK_RECEIPT_TRANSACTION_REQUEST, GET_BANK_RECEIPT_TRANSACTIONS, BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE,
  GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_TRANSACTIONS, GET_BANK_NAME_BANK_RECEIPT_TRANSACTIONS } from '../types';

const initialState = {
  bankReceiptTransactions: [],
  accountIdWiseConsigneeBankReceiptTransactions: [],
  bankNamesBankReceiptTransactions: [],
  loading: false,
  error: null,
};

const bankReceiptTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_RECEIPT_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_RECEIPT_TRANSACTIONS: {
      return {
        ...state,
        bankReceiptTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_TRANSACTIONS: {
      const { data } = action.payload || {};
      return {
        ...state,
        accountIdWiseConsigneeBankReceiptTransactions: [...data],
        loading: false,
        error: null
      }
    }
    case GET_BANK_NAME_BANK_RECEIPT_TRANSACTIONS: {
      const { data } = action.payload || {};
      console.log('data>>>', data);
      
      return {
        ...state,
        bankNamesBankReceiptTransactions: [...data],
        loading: false,
        error: null
      }
    }
    case BANK_RECEIPT_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankReceiptTransactionReducer;